<template>
  <slot />
</template>

<script lang="ts" setup>
defineOptions({
  name: 'LtCollectionItem',
  inheritAttrs: false,
})
</script>
